export function removeEmptyProperties(originalObject: { [x: string]: unknown }) {
  return Object.fromEntries(Object.entries(originalObject ?? {}).filter(([, value]) => value))
}

export function removeDuplicateProperties(originalObject: { [x: string]: unknown }) {
  const newObject: { [x: string]: unknown } = {}

  Object.entries(originalObject ?? {}).forEach(([key, value]) => {
    if (!newObject[key]) {
      newObject[key] = value
    }
  })

  return newObject
}
